// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchPopup-watcher___e0f1c411def4f753d4a{background-color:inherit;border-radius:6px;display:flex;position:relative;justify-content:space-between;align-items:center;padding:21px 22px 23px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"watcher": "SearchPopup-watcher___e0f1c411def4f753d4a"
};
export default ___CSS_LOADER_EXPORT___;
